import React from "react";
import clsx from "clsx";

import { NumericInputRow, SelectInputRow } from "./components";
import * as styles from "./component.module.scss";

const InputRowBase = React.forwardRef<
  HTMLInputElement,
  {
    variants?: ("full-width" | "disabled")[];
    label?: string;
    error?: string;
    icon?: React.ReactNode;
    labelIcon?: React.ReactNode;
    iconTooltip?: string;
    onIconClick?: () => void;
    classNames?: {
      root?: string;
      label?: string;
      input?: string;
      inputWrapper?: string;
      error?: string;
      icon?: string;
      labelIcon?: string;
    };
  } & JSX.IntrinsicElements["input"]
>(
  (
    {
      variants,
      label,
      error,
      icon,
      labelIcon,
      iconTooltip,

      onIconClick,
      classNames,
      type,
      value,
      defaultValue,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={clsx(
          styles.root,
          variants?.includes("full-width") && styles.fullWidth,
          classNames?.root
        )}
      >
        {label && (
          <label className={clsx(styles.label, classNames?.label)}>
            {label}
            {labelIcon && <p className={styles.noMargin}>{labelIcon}</p>}
          </label>
        )}
        <div className={clsx(styles.inputWrapper, classNames?.inputWrapper)}>
          <input
            {...props}
            {...{ type, value, defaultValue }}
            className={clsx(
              styles.input,
              variants?.includes("disabled") && styles.disabled,
              error && clsx(styles.error, classNames?.error),
              classNames?.input
            )}
            ref={ref}
          />
          <div
            className={clsx(styles.icon, classNames?.icon)}
            onClick={(e) => {
              e.stopPropagation();
              onIconClick && onIconClick();
            }}
          >
            {icon}
          </div>
        </div>
        {error && (
          <span className={clsx(styles.error, classNames?.error)}>{error}</span>
        )}
      </div>
    );
  }
);

const InputRow = Object.assign(InputRowBase, {
  Numeric: NumericInputRow,
  Select: SelectInputRow,
});

export { InputRow };
